import { getPurchased } from "@/lib/access";
import { MOCK_TICKETS, findEvent } from "@/lib/mockData";

// Merge baseline demo tickets with locally-purchased ones (deduped).
export const mergedTickets = () => {
  const all = [...MOCK_TICKETS, ...getPurchased()];
  const seen = new Set();
  const out = [];
  for (const t of all) {
    const k = `${t.eventId}|${t.type}`;
    if (!seen.has(k)) {
      seen.add(k);
      out.push(t);
    }
  }
  return out;
};

export const ownsEvent = (eventId) =>
  mergedTickets().some((t) => t.eventId === eventId);

export const bestTypeForEvent = (eventId) => {
  const ts = mergedTickets().filter((t) => t.eventId === eventId);
  if (ts.some((t) => t.type === "online")) return "online";
  return ts.length ? ts[0].type : null;
};

// Derive live/ticket phase from event timing + ticket type.
export const computeStatus = (event, type) => {
  const now = Date.now();
  const start = new Date(event.startsAt).getTime();
  const end = event.endsAt
    ? new Date(event.endsAt).getTime()
    : start + 2 * 3600 * 1000;

  if (now < start) return { phase: "upcoming", start, end };
  if (now <= end) return { phase: "active", start, end };

  const dur = type === "online" && event.replay ? event.replay.durationHours : 0;
  if (dur && now <= end + dur * 3600 * 1000) {
    return {
      phase: "replay",
      start,
      end,
      replayExpiresAt: new Date(end + dur * 3600 * 1000).toISOString(),
    };
  }
  return { phase: "expired", start, end };
};

export const myTickets = () =>
  mergedTickets()
    .map((t) => {
      const event = findEvent(t.eventId);
      if (!event) return null;
      return { ticket: t, event, status: computeStatus(event, t.type) };
    })
    .filter(Boolean);
